import { useEffect, useState } from 'react';
import { apiRequest, ApiError } from '../../api/http';
import { PublicHeader, PublicFooter, usePublicLocale } from '../../layouts/PublicFrame';
import { appUrl } from '../../config/appUrl';
import { navigateToApp } from '../../auth/appNavigation';
import { Spinner } from '../../shared/components';
import '../content/content.css';

type Campaign = {
  campaign_id: string; name: string; description?: string; image_url?: string; banner_image?: string; banner_url?: string; banner_images?: { url?: string }[]; cafe_id?: string;
  reward_point: number; reward_point_max?: number; status: string;
  cafe_name?: string; rights_remaining?: number; minimum_text_length?: number;
  minimum_photo_count?: number; photo_or_video?: boolean; video_required?: boolean;
  deep_review_required?: boolean; valid_to?: string; campaign_closed_reason?: string;
};

export function PublicCampaignPage({ id }: { id: string }) {
  const { locale, changeLocale } = usePublicLocale();
  const [campaign, setCampaign] = useState<Campaign | null>(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!id) return;
    const abort = new AbortController();
    setCampaign(null); setError('');
    apiRequest<Campaign>(`/creator/campaigns/${encodeURIComponent(id)}`, { query: { browse_only: true }, signal: abort.signal })
      .then(value => { if (!abort.signal.aborted) setCampaign(value); })
      .catch(reason => { if (!abort.signal.aborted) setError(reason instanceof ApiError && reason.status === 404 ? 'ไม่พบแคมเปญนี้ หรือแคมเปญสิ้นสุดแล้ว' : 'โหลดแคมเปญไม่สำเร็จ กรุณาลองอีกครั้ง'); });
    return () => abort.abort();
  }, [id, attempt]);
  const query = new URLSearchParams({ campaign_id: id });
  if (campaign?.cafe_id) query.set('cafe_id', campaign.cafe_id);
  const path = id ? `/commu/create?${query}` : '/campaigns?view=list';
  const image = [campaign?.banner_image, campaign?.banner_url, campaign?.banner_images?.[0]?.url, campaign?.image_url].find(value => value && /^https?:\/\//.test(value));
  const placeName = campaign?.cafe_name === 'Any eligible place' ? 'ร้านที่ตรงตามเงื่อนไขแคมเปญ' : campaign?.cafe_name;
  const closed = campaign && ['closed', 'expired', 'budget_exhausted', 'archived', 'stopped'].includes(campaign.status);
  return <div className="public-content">
    <PublicHeader locale={locale} onLocaleChange={changeLocale} />
    <main className="content-view">
      {!id ? <article className="content-view__post"><h1>แคมเปญรีวิวบน Beaw</h1><a className="button button--primary" href={appUrl(path)} onClick={event => { event.preventDefault(); void navigateToApp(path); }}>ดูแคมเปญในแอป</a></article>
        : error ? <article className="content-view__post" role="alert"><h1>{error}</h1><button className="button" onClick={() => setAttempt(value => value + 1)}>ลองใหม่</button></article>
        : !campaign ? <Spinner /> : <article className="content-view__post">
          {image && <img src={image} alt={campaign.name} style={{ width: '100%', maxHeight: 360, objectFit: 'contain', borderRadius: 16 }} />}
          <h1>{campaign.name}</h1>
          <p><strong>รับสูงสุด {campaign.reward_point_max ?? campaign.reward_point} แต้ม</strong></p>
          {closed ? <p role="status">{campaign.campaign_closed_reason || 'แคมเปญนี้ปิดรับแล้ว'}</p> : <a className="button button--primary" href={appUrl(path)} onClick={event => { event.preventDefault(); void navigateToApp(path); }}>ไปโพสต์รีวิว</a>}
          {placeName && <p>ร้าน: {placeName}</p>}
          {campaign.description && <p className="content-view__body">{campaign.description}</p>}
          <h2>เงื่อนไขการรีวิว</h2>
          <ul>
            {!!campaign.minimum_text_length && <li>เขียนรีวิวอย่างน้อย {campaign.minimum_text_length} ตัวอักษร</li>}
            {!!campaign.minimum_photo_count && <li>แนบรูปอย่างน้อย {campaign.minimum_photo_count} รูป{campaign.photo_or_video ? ' หรือคลิปตามเงื่อนไขแคมเปญ' : ''}</li>}
            {campaign.video_required && <li>แนบคลิปรีวิว</li>}
            {campaign.deep_review_required && <li>ทำรีวิวแบบลึกให้ครบก่อนรับรางวัล</li>}
            <li>ตรวจเงื่อนไขและเข้าร่วมแคมเปญในแอปก่อนรีวิว</li>
          </ul>

        </article>}
    </main><PublicFooter />
  </div>;
}
